import React, { useContext, useMemo } from 'react';

let globalId = 0;

const UniqueIdContext = React.createContext<{
    nextId(): number;
}>({
    nextId(): number {
        return globalId++;
    }
});

export function useUniqueId(prefix: string): string {
    const ctx = useContext(UniqueIdContext);
    const id = useMemo(() => ctx.nextId(), [ctx]);
    return useMemo(() => `${prefix}${id}`, [prefix, id]);
}
